var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"err_frame"},[_c('div',{staticClass:"error"},[_c('img',{staticClass:"bg",attrs:{"src":require("@/assets/error/404.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("404 - 未找到当前页面")]),_c('button',{staticClass:"back",on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }